<template>
  <div class="navi">
    <div class="user-container">
      <div class="profile-picture">
        <template v-if="myProfilePictureUrl">
          <img v-bind:src="myProfilePictureUrl">
        </template>
        <template v-else>
          <comp-icon
          v-bind:icon="'person'"
          v-bind:width="48"></comp-icon>
        </template>
      </div>
      <div class="name">{{myName}}</div>
    </div>
    <div
    v-if="myDealerHasPendingRegistration && iAmOwnerOfMyDealer && !isIPAuth"
    v-on:click="onClickDealerRegistration()" ontouchstart=""
    class="navi-item alarm">Click to complete your dealer registration</div>
    <div
    v-if="isToResetPassword && !isIPAuth"
    v-on:click="onClickChangePassword()" ontouchstart=""
    class="navi-item alarm">Please change your password</div>
    <div
    v-on:click="goTo('Profile')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'Profile'
    }"
    class="navi-item">Profile</div>
    <div
    v-if="!isIPAuth"
    v-on:click="goTo('Security')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'Security'
    }"
    class="navi-item">Two-Factor Authentication</div>
    <div
    v-if="hasMyDevices && !isIPAuth"
    v-on:click="goTo('Devices')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'Devices'
    }"
    class="navi-item">Devices</div>
    <div
    v-if="hasMyAccessHistory && !isIPAuth"
    v-on:click="goTo('AccessHistory')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'AccessHistory'
    }"
    class="navi-item">Access History</div>
    <div
    v-if="hasMySites && !isIPAuth"
    v-on:click="goTo('CustomerTools')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'CustomerTools'
    }"
    class="navi-item">Customer Tools</div>
    <div
    v-if="hasMyDealer"
    v-on:click="goTo('DealerTools')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'DealerTools'
    }"
    class="navi-item">Dealer Tools</div>
    <div
    v-if="isCHeKTAdmin && !isIPAuth"
    v-on:click="goTo('AdminTools')" ontouchstart=""
    v-bind:class="{
      selected: getCurrentRouteName() === 'AdminTools'
    }"
    class="navi-item">Admin Tools</div>
    <div
    v-on:click="onClickLogout()" ontouchstart=""
    class="navi-item">Logout</div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'navi',
  components: {
    CompIcon
  },
  computed: {
    myProfilePictureUrl: function () {
      return this.$store.getters.myProfilePictureUrl
    },
    myName: function () {
      return this.$store.getters.myFirstName ? this.$store.getters.myFirstName + ' ' + this.$store.getters.myLastName : ''
    },
    isCHeKTAdmin: function () {
      return this.$store.getters.isCHeKTAdmin
    },
    hasMyDealer: function () {
      return this.$store.getters.hasMyDealer
    },
    hasMySites: function () {
      return this.$store.getters.hasMySites
    },
    hasMyDevices: function () {
      return this.$store.getters.hasMyDevices
    },
    hasMyAccessHistory: function () {
      return this.$store.getters.hasMyAccessHistory
    },
    myDealerHasPendingRegistration: function () {
      return this.$store.getters.myDealerHasPendingRegistration
    },
    iAmOwnerOfMyDealer: function () {
      return this.$store.getters.iAmOwnerOfMyDealer
    },
    isToResetPassword: function () {
      return this.$store.getters.isToResetPasswordAuth0 && (this.$store.getters.accountCreatedDate > this.$store.getters.newAccountLogicBeginDate)
    },
    isIPAuth: function (state) {
      return !!this.$store.getters.idTokenIPAuthDealerID
    }
  },
  methods: {
    goTo: function (routeName) {
      this.$router.push({name: routeName, query: this.$route.query})
      this.$forceUpdate()
      this.$emit('onClickMenu', null)
    },
    onClickLogout: function () {
      this.$emit('onClickLogout', null)
    },
    onClickDealerRegistration: function () {
      this.$emit('onClickDealerRegistration', null)
    },
    onClickChangePassword: function () {
      this.$emit('onClickChangePassword', null)
    },
    getCurrentRouteName: function () {
      return this.$router.currentRoute.name
    }
  }
}
</script>

<style scoped>

.navi {
  /* position */
  margin-top: 0em;
  /* alignment */
  text-align: left;
}

.navi .navi-item {
  /* common */
  color: var(--gray-medium);
  font-size: 14px;
  /* text */
  font-weight: bold;
  /* border */
  border-top: 1px solid hsla(202, 100%, 100%, 0);
  border-bottom: 1px solid hsla(202, 100%, 100%, 0);
  border-left: 4px solid hsla(202, 100%, 50%, 0);
  border-radius: 4px;
  /* size */
  padding: .5em;
  padding-left: 1.5em;
  /* position */
  margin: 4px 8px;
  /* mouse */
  cursor: pointer;
}
.navi .navi-item.selected {
  /* common */
  color: var(--gray-high);
  background-color: #dedede;
  /* border */
  border-top: 1px solid hsla(202, 100%, 100%, 0.1);
  border-bottom: 1px solid hsla(202, 100%, 100%, 0.1);
  /* border-left: 4px solid var(--primary); */
}
.navi .navi-item:hover {
  /* common */
  background-color: #e5e5e5;
}

.navi .navi-item.alarm {
  /* common */
  font-size: 11.5px;
  background-color: hsla(0, 100%, 65%, 1);
  /* border */
  border-top: 1px solid hsla(202, 100%, 100%, 0.1);
  border-bottom: 1px solid hsla(202, 100%, 100%, 0.1);
}


.navi .user-container {
  /* common */
  color: var(--gray-high);
  background-color: #f0f0f0;
  font-size: 14px;
  /* text */
  font-weight: bold;
  /* size */
  width: calc(100% - 1em);
  padding: 0 0.5em;
  height: 150px;
  /* position */
  position: relative;
  /* alignment */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.navi .user-container .name {
  /* size */
  width: calc(100% - 2em);
  padding: 0 1em;
  /* position */
  margin-top: 0.5em;
  /* text */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.navi .user-container .profile-picture {
  /* common */
  overflow: hidden;
  /* size */
  padding: 0;
  width: 70px;
  height: 70px;
  /* border */
  border: 1px solid hsla(0, 0%, 100%, 0.3);
  border-radius: 50%;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.navi .user-container .profile-picture > img {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  z-index: 1;
}


</style>



// WEBPACK FOOTER //
// src/pages/Account/Navi.vue